import { CustomStorageProvider } from './../../providers/custom-storage/custom-storage';
import { RestService } from './../../services/restService';
import { Component } from '@angular/core';
import { ActionSheetController, IonicPage, NavController, NavParams, ViewController, AlertController, ModalController, Platform } from 'ionic-angular';
import { Constants } from '../../util/Constants';
import { TranslateService } from '@ngx-translate/core';
import { FbConfig } from '../../util/FbConfig';
import { WebSocketService } from '../../services/webSocketService';
import { LoadingCtrlProvider } from '../../providers/loading-ctrl/loading-ctrl';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
declare var CryptoJS: any;

@IonicPage({
  // defaultHistory: ['StartUpPage']
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  phone: number;
  password: string;
  rememberMe: boolean;
  phonePrefix: string;
  isIos: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public restService: RestService, public viewCtrl: ViewController, public customStorageService: CustomStorageProvider,
    public platform: Platform,
    public alertCtrl: AlertController, public translateService: TranslateService, private actionSheetCtrl: ActionSheetController,
    private webSocketService: WebSocketService, private modalCtrl: ModalController, private loadingCtrl: LoadingCtrlProvider) {
      this.isIos = platform.is("ios");
  }

  ionViewDidLoad() {
    this.phonePrefix = "852";
    this.rememberMe = this.customStorageService.get<boolean>(Constants.STORAGE_KEY_REMEMBER_ME);
  }

  ionViewDidEnter() {
    if (this.rememberMe) {
      let phoneNumber = this.customStorageService.get<number>(Constants.STORAGE_KEY_PHONELOGIN_PHONENUMBER);
      if (phoneNumber.toString().slice(0, 2) == "86") {
        this.phonePrefix = phoneNumber.toString().slice(0, 2);
        this.phone = Number(phoneNumber.toString().substring(2));
      } else {
        this.phonePrefix = phoneNumber.toString().slice(0, 3);
        this.phone = Number(phoneNumber.toString().substring(3));
      }
      let savedPassword = this.customStorageService.get<string>(Constants.STORAGE_KEY_PHONELOGIN_PASSWORD);
      this.password = CryptoJS.AES.decrypt(savedPassword, Constants.ENCRYPT_PASSPHASE).toString(CryptoJS.enc.Utf8);
    }


  }

  changePrefix() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translateService.instant("prefixLabel"),
      buttons: [
        {
          text: this.translateService.instant("cancel"),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translateService.instant("prefix852"),
          handler: () => {
            this.phonePrefix = "852";
          }
        },
        {
          text: this.translateService.instant("prefix86"),
          handler: () => {
            this.phonePrefix = "86";
          }
        },
        {
          text: this.translateService.instant("prefix853"),
          handler: () => {
            this.phonePrefix = "853";
          }
        }
      ]
    });

    actionSheet.present();
  }

  login() {
      if (this.phone == null || this.password == "") {
        let errorAlert = this.alertCtrl.create({
          "title": this.translateService.instant("error"),
          "subTitle": this.translateService.instant("invalidInput"),
          buttons: [this.translateService.instant("ok")]
        });
        errorAlert.present();
        return;
      }
    this.loadingCtrl.createCmdLoading(Constants.LOADING_CTRL_CODE_LOGIN);
    let loginPhone = this.phonePrefix + this.phone;
    this.restService.login(loginPhone, this.password).then(
      result => {
        let userId = result.id;
        let webSecret = result.webSecret;
        let assignedHost = result.assignedHost;
        let role = result.role;
        let nickname = result.nickname;
        let phoneNumber = result.mobileNumber;

        if (FbConfig.DEBUG) {
          this.customStorageService.set(Constants.STORAGE_KEY_WEB_SOCKET_URL, FbConfig.DEBUG_WEB_SOCKET_PATH);
          //this.customStorageService.set(Constants.STORAGE_KEY_FB_WEB_SOCKET_URL, FbConfig.DEBUG_FB_WEB_SOCKET_PATH);
        } else {
          this.customStorageService.set(Constants.STORAGE_KEY_WEB_SOCKET_URL, "wss://" + assignedHost + "/fads/ws/client");
          //this.customStorageService.set(Constants.STORAGE_KEY_FB_WEB_SOCKET_URL, "wss://" + assignedHost + "/fads/ws/clientFb");
        }

        this.customStorageService.set(Constants.STORAGE_KEY_USER_ID, userId);
        this.customStorageService.set(Constants.STORAGE_KEY_WEB_SECRET, webSecret);
        this.customStorageService.set(Constants.STORAGE_KEY_ROLE, role);
        this.customStorageService.set(Constants.STORAGE_KEY_NICKNAME, nickname);
        this.customStorageService.set(Constants.STORAGE_KEY_PHONELOGIN_PHONENUMBER, phoneNumber);
        this.customStorageService.set(Constants.STORAGE_KEY_PHONELOGIN_PASSWORD, CryptoJS.AES.encrypt(this.password, Constants.ENCRYPT_PASSPHASE).toString());
        this.customStorageService.set(Constants.STORAGE_KEY_REMEMBER_ME, this.rememberMe);

        //this.viewCtrl.dismiss({app: this.appCtrl});
        //this.events.publish("loginSuccess");
        this.webSocketService.connectWS();
        this.webSocketService.connectionStatusSubject.asObservable()
          .filter(val => val == true)
          .take(1)
          .subscribe(isConnected => {
            if (isConnected) {
              this.loadingCtrl.dismissCmdLoading(Constants.LOADING_CTRL_CODE_LOGIN);
              this.navCtrl.setRoot("GridMenuPage", {}, { animate: true, direction: 'forward' });
            }
          });
      },
      err => {
        console.log(err);
        this.loadingCtrl.dismissCmdLoading(Constants.LOADING_CTRL_CODE_LOGIN); 
        if(navigator.onLine){
          let errStatus = err.status;
          let errCode = err.code;          
          if ((errStatus >= 400 && errStatus < 500) || errStatus == 0) {
            let invalidAlert = this.alertCtrl.create({
              "title": this.translateService.instant("loginFailedTitle"),
              "subTitle": this.translateService.instant("serverInvalid"),
              buttons: [this.translateService.instant("ok")]
            });
            invalidAlert.present();
          } else if(errCode == undefined){
            let undefinedAlert = this.alertCtrl.create({
              "title": this.translateService.instant("loginFailedTitle"),
              "subTitle": this.translateService.instant("connectionError"),
              buttons: [this.translateService.instant("ok")]
            });
            undefinedAlert.present();
          } else {                          
            let errorAlert = this.alertCtrl.create({
              "title": this.translateService.instant("loginFailedTitle"),
              "subTitle": this.translateService.instant("loginFailedContent"),
              buttons: [this.translateService.instant("ok")]
            });
            errorAlert.present();         
          }           
        } else {
          let offlineAlert = this.alertCtrl.create({
            "title": this.translateService.instant("loginFailedTitle"),
            "subTitle": this.translateService.instant("userOffline"),
            buttons: [this.translateService.instant("ok")]
          });
          offlineAlert.present();
        }        
      }
    )
  }
  
  toggleRememberMe() {
    this.rememberMe = !this.rememberMe;
  }

  forgotPassword() {
    let modal = this.modalCtrl.create("ForgotPasswordPage");
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts